module.exports = __webpack_public_path__ + "static/img/tutorial-tool-competitiveness-2.b324ae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-tool-competitiveness-2.jpg
// module id = tPka
// module chunks = 3